import * as ajax from "../../actions/ajaxCounterActions";
import * as exception from "../../actions/exceptionActions";
import * as domainConstants from "../../constants/DomainConstants";

import geographyApi from "../../api/geographyApi";

import { getStore } from "../../store/configureStore";

import showToastr from "../../util/toastr.js";
import redirector from "../../util/redirector";
import GenerateGuid from "../../util/guid";
import mergeDeep from "../../util/mergeDeep";


export default class InfrastructuurInDeBuurtDetailPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const isNew = this.context.props.route.params.isNew;
		const mapKey = GenerateGuid();
		const sportinfrastructurenInDeBuurt = this.context.props.sportinfrastructurenInDeBuurt;
		const index = this.context.props.index;
		const documenten = this.context.props.documenten;
		const fileSessionStarted = this.context.props.fileSessionStarted;

		this.context.setState({
			model: null,
			isNew,
			isSpakki: false,
			mapKey,
			mapEditMode: false,
			mapDraggable: false,
			mapCenter: null,
			mapNewCoords: null,
			documenten: documenten,
			fileSessionStarted: fileSessionStarted,
			sportinfrastructurenInDeBuurt: sportinfrastructurenInDeBuurt
		});

		if (!isNew) {
			const currentSportinfrastructuurInDeBuurt = Object.assign({}, sportinfrastructurenInDeBuurt.find(i => i.id == index));
			this.loadSportInfrastructuurInDeBuurt(currentSportinfrastructuurInDeBuurt);
		}
		else {
			this.getNewSportInfrastructuurInDeBuurt();
		}
	}

	loadLayout() {
		const dossierId = this.context.props.dossierId;

		this.context.props.loadLayout(dossierId, true, this.context.props.params.infrastructuurId, true);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	change(event, data) {
		const target = event.target;
		let model = this.context.state.model;

		if (data) {
			const field = data.name;
			model[field] = data.value;
		} else {
			const field = target.name;
			model[field] = target.value;

			if (target.name === "soortWerken") {
				model.bouwjaar = null;
				model.renovatiejaar = null;
			}
		}

		this.context.setState({ model: model, hasUnsavedChanges: true });
	}

	getInfrastructuur(infrastructuurId) {
		const sportinfrastructurenInDeBuurt = this.context.props.sportinfrastructurenInDeBuurt;
		let model = mergeDeep({}, sportinfrastructurenInDeBuurt.find(x => x.id === infrastructuurId));

		if (model && model.spakki && model.spakki.id) //SpakkiInfrastructuren moeten type Renovatie zijn.
		{
			model = Object.assign({}, model, { soortWerken: domainConstants.INFRASTRUCTUUR_TYPE.RENOVATIE });
		}

		this.setStateAfterUpdate(model);
		this.loadLayout(model);
	}

	getNewSportInfrastructuurInDeBuurt() {
		this.context.props.getEmptySportInfrastructuurInDeBuurt().then(empty => {
			this.setStateAfterUpdate(empty);
			this.loadLayout(empty);
		});
	}

	loadSportInfrastructuurInDeBuurt(currentSportinfrastructuurInDeBuurt) {
		this.setStateAfterUpdate(currentSportinfrastructuurInDeBuurt);
		this.loadLayout(currentSportinfrastructuurInDeBuurt);
	}

	replacePoint() {
		this.context.setState({
			mapEditMode: true
		});
	}

	onDragEnd(e) {
		const movedMarker = mergeDeep({}, this.context.state.mapNewCoords);

		movedMarker.lat = e.target.getLatLng().lat;
		movedMarker.lng = e.target.getLatLng().lng;

		this.context.setState({
			mapNewCoords: movedMarker
		});
	}

	getGeoCoordinates(event) {
		let model = this.context.state.model;

		let adres = {
			gemeenteId: model.gemeente,
			postcodeId: model.postcode,
			straatHuisnummer: model.straatEnHuisnummer
		};

		this.dispatch(ajax.started());
		geographyApi.getCoordinatenForAdres(adres)
			.then(result => {
				this.dispatch(ajax.ended());
				const data = result.data;
				if (data.lengtegraad && data.breedtegraad) {
					model.lengtegraad = data.lengtegraad;
					model.breedtegraad = data.breedtegraad;
					const mapCenter = Object.assign({}, { lat: parseFloat(data.breedtegraad), lng: parseFloat(data.lengtegraad) });
					const mapNewCoords = Object.assign({}, { lat: parseFloat(data.breedtegraad), lng: parseFloat(data.lengtegraad) });

					this.context.setState({
						model,
						mapCenter,
						mapNewCoords
					});
				} else {
					showToastr(domainConstants.NO_GEOCOORDINATEN_FOUND2);
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	save() {
		const context = this.context;
		const state = context.state;
		const props = context.props;
		const model = state.model;
		const documenten = state.documenten;
		const fileSessionStarted = state.fileSessionStarted;
		const isSaved = props.bovenLokaliteitPerInfrastructuur.isSaved && !state.hasUnsavedChanges;
		const dossierId = props.dossierId;
		const infrastructuurId = props.params.infrastructuurId;
		model.dossierId = dossierId;
		model.infrastructuurId = infrastructuurId;

		this.context.props.saveBovenLokaliteitPerInfrastructuur(model, documenten, fileSessionStarted, isSaved)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					this.goToOverview();
				}
			});
	}

	cancel() {
		const isNew = this.context.state.isNew;

		if (!isNew) {
			this.context.props.resetInfrastructuurErrors();
		}

		this.context.setState({ hasUnsavedChanges: false });
		this.goToOverview();
	}

	saveNewPoint() {
		const state = this.context.state;
		const model = Object.assign({}, state.model);
		const newCoordinates = Object.assign({}, state.mapNewCoords);
		model.lengtegraad = newCoordinates.lng;
		model.breedtegraad = newCoordinates.lat;
		this.context.setState({
			mapEditMode: false,
			mapKey: GenerateGuid(),
			model
		});
	}

	cancelReplace() {
		const state = this.context.state;
		const model = state.model;
		let originalCoordinates = Object.assign({}, { lat: parseFloat(model.breedtegraad), lng: parseFloat(model.lengtegraad) });
		this.context.setState({
			mapEditMode: false,
			mapCenter: originalCoordinates,
			mapNewCoords: originalCoordinates
		});
	}

	goToOverview() {
		const infrastructuurId = this.context.props.bovenLokaliteitPerInfrastructuur.item.infrastructuur.id;
		redirector.goTo(`/bovenlokaliteit/${this.context.props.params.dossierId}/infrastructuur/${infrastructuurId}`);
	}

	isReadyToRender() {
		if (!this.context.state.model) {
			return false;
		}

		if (!this.context.props.soortenInfrastructuur || !this.context.props.soortenInfrastructuur.length > 0) {
			return false;
		}

		if (!this.context.props.gemeenten || !this.context.props.gemeenten.length > 0) {
			return false;
		}

		if (!this.context.props.postcodes || !this.context.props.postcodes.length > 0) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		const hasCoordinates = item.breedtegraad && item.lengtegraad;
		const coords = hasCoordinates ? Object.assign({}, { lat: parseFloat(item.breedtegraad), lng: parseFloat(item.lengtegraad) }) : null;
		this.context.setState({
			model: item,
			model_original: item,
			mapCenter: coords,
			mapNewCoords: coords,
			isSpakki: !!(item.spakki && item.spakki.id)
		});
	}
}